import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AddressService } from "src/service/address.service";
import { CheckoutService } from "../checkout.service";

@Component({
  selector: "app-checkout-address",
  templateUrl: "./checkout-address.component.html",
  styleUrls: ["../../dashboard.style.scss"],
})
export class CheckoutAddressComponent implements OnInit {
  constructor(
    private checkoutService: CheckoutService,
    private router: Router,
    private route: ActivatedRoute,
    private addressService: AddressService
  ) {}

  addressForm: FormGroup;
  states;
  cities;
  countries = this.addressService
    .getCountryListForCargo();
    // .pipe(map((list) => list.filter((item) => item.englishName == "Germany")));

  ngOnInit(): void {
    this.addressForm = new FormGroup({
      country: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
      state: new FormControl("", Validators.required),
      no: new FormControl("", Validators.required),
      zipcode: new FormControl("", Validators.required),
      address: new FormControl("", Validators.required),
    });

    this.states = this.addressForm
      .get("country")
      .valueChanges.pipe(
        switchMap((country) => this.addressService.getStateList(country))
      );

    this.cities = combineLatest([
      this.addressForm.get("state").valueChanges,
      this.addressForm.get("country").valueChanges,
    ]).pipe(
      switchMap(([state, country]: any) =>
        this.addressService.getCityList(country, state)
      )
    );
  }

  onSubmit() {
    this.checkoutService.refreshCheckout(this.addressForm.value);
    this.checkoutService.refreshValues();

    this.router.navigate(["..", "payment"], { relativeTo: this.route });
  }
}
